import { mapGetters } from 'vuex'

// returns if user is professinal or company
export default {
  ...mapGetters(['user', 'userIsCompany'])
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/form/resources/computed.js